import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import Link from './Link';

const SignUpLink = ({ onClick, tenantId }) => {
  const { formatMessage } = useIntl();
  return (
    <Link onClick={onClick}>
      {formatMessage({ id: `${tenantId}.page.login.label.noAccount` })}
    </Link>
  );
};

SignUpLink.propTypes = {
  onClick: PropTypes.func.isRequired,
  tenantId: PropTypes.oneOf([
    'kiniseko',
    'skye',
    'nisekocentral',
  ]).isRequired,
};

export default SignUpLink;
